package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class AcupointName(private val literal: String) : IEnumType {
	中府("中府"),
	云门("云门"),
	天府("天府"),
	侠白("侠白"),
	尺泽("尺泽"),
	孔最("孔最"),
	列缺("列缺"),
	经渠("经渠"),
	太渊("太渊"),
	鱼际("鱼际"),
	少商("少商"),
	商阳("商阳"),
	二间("二间"),
	三间("三间"),
	合谷("合谷"),
	阳溪("阳溪"),
	偏历("偏历"),
	温溜("温溜"),
	下廉("下廉"),
	上廉("上廉"),
	手三里("手三里"),
	曲池("曲池"),
	肘髎("肘髎"),
	手五里("手五里"),
	臂臑("臂臑"),
	肩髃("肩髃"),
	巨骨("巨骨"),
	天鼎("天鼎"),
	扶突("扶突"),
	口禾髎("口禾髎"),
	迎香("迎香"),
	承泣("承泣"),
	四白("四白"),
	巨髎("巨髎"),
	地仓("地仓"),
	大迎("大迎"),
	颊车("颊车"),
	下关("下关"),
	头维("头维"),
	人迎("人迎"),
	水突("水突"),
	气舍("气舍"),
	缺盆("缺盆"),
	气户("气户"),
	库房("库房"),
	屋翳("屋翳"),
	膺窗("膺窗"),
	乳中("乳中"),
	乳根("乳根"),
	不容("不容"),
	承满("承满"),
	梁门("梁门"),
	关门("关门"),
	太乙("太乙"),
	滑肉门("滑肉门"),
	天枢("天枢"),
	外陵("外陵"),
	大巨("大巨"),
	水道("水道"),
	归来("归来"),
	气冲("气冲"),
	髀关("髀关"),
	伏兔("伏兔"),
	阴市("阴市"),
	梁丘("梁丘"),
	犊鼻("犊鼻"),
	足三里("足三里"),
	上巨虚("上巨虚"),
	条口("条口"),
	下巨虚("下巨虚"),
	丰隆("丰隆"),
	解溪("解溪"),
	冲阳("冲阳"),
	陷谷("陷谷"),
	内庭("内庭"),
	厉兑("厉兑"),
	隐白("隐白"),
	大都("大都"),
	太白("太白"),
	公孙("公孙"),
	商丘("商丘"),
	三阴交("三阴交"),
	漏谷("漏谷"),
	地机("地机"),
	阴陵泉("阴陵泉"),
	血海("血海"),
	箕门("箕门"),
	冲门("冲门"),
	府舍("府舍"),
	腹结("腹结"),
	大横("大横"),
	腹哀("腹哀"),
	食窦("食窦"),
	天溪("天溪"),
	胸乡("胸乡"),
	周荣("周荣"),
	大包("大包"),
	极泉("极泉"),
	青灵("青灵"),
	少海("少海"),
	灵道("灵道"),
	通里("通里"),
	阴郄("阴郄"),
	神门("神门"),
	少府("少府"),
	少冲("少冲"),
	少泽("少泽"),
	前谷("前谷"),
	后溪("后溪"),
	腕骨("腕骨"),
	阳谷("阳谷"),
	养老("养老"),
	支正("支正"),
	小海("小海"),
	肩贞("肩贞"),
	臑俞("臑俞"),
	天宗("天宗"),
	秉风("秉风"),
	曲垣("曲垣"),
	肩外俞("肩外俞"),
	肩中俞("肩中俞"),
	天窗("天窗"),
	天容("天容"),
	颧髎("颧髎"),
	听宫("听宫"),
	睛明("睛明"),
	攒竹("攒竹"),
	眉冲("眉冲"),
	曲差("曲差"),
	五处("五处"),
	承光("承光"),
	通天("通天"),
	络却("络却"),
	玉枕("玉枕"),
	天柱("天柱"),
	大杼("大杼"),
	风门("风门"),
	肺俞("肺俞"),
	厥阴俞("厥阴俞"),
	心俞("心俞"),
	督俞("督俞"),
	膈俞("膈俞"),
	肝俞("肝俞"),
	胆俞("胆俞"),
	脾俞("脾俞"),
	胃俞("胃俞"),
	三焦俞("三焦俞"),
	肾俞("肾俞"),
	气海俞("气海俞"),
	大肠俞("大肠俞"),
	关元俞("关元俞"),
	小肠俞("小肠俞"),
	膀胱俞("膀胱俞"),
	中膂俞("中膂俞"),
	白环俞("白环俞"),
	上髎("上髎"),
	次髎("次髎"),
	中髎("中髎"),
	下髎("下髎"),
	会阳("会阳"),
	承扶("承扶"),
	殷门("殷门"),
	浮郄("浮郄"),
	委阳("委阳"),
	委中("委中"),
	附分("附分"),
	魄户("魄户"),
	膏肓("膏肓"),
	神堂("神堂"),
	譩譆("譩譆"),
	膈关("膈关"),
	魂门("魂门"),
	阳纲("阳纲"),
	意舍("意舍"),
	胃仓("胃仓"),
	肓门("肓门"),
	志室("志室"),
	胞肓("胞肓"),
	秩边("秩边"),
	合阳("合阳"),
	承筋("承筋"),
	承山("承山"),
	飞扬("飞扬"),
	跗阳("跗阳"),
	昆仑("昆仑"),
	仆参("仆参"),
	申脉("申脉"),
	金门("金门"),
	京骨("京骨"),
	束骨("束骨"),
	足通谷("足通谷"),
	至阴("至阴"),
	涌泉("涌泉"),
	然谷("然谷"),
	太溪("太溪"),
	大钟("大钟"),
	水泉("水泉"),
	照海("照海"),
	复溜("复溜"),
	交信("交信"),
	筑宾("筑宾"),
	阴谷("阴谷"),
	横骨("横骨"),
	大赫("大赫"),
	气穴("气穴"),
	四满("四满"),
	中注("中注"),
	肓俞("肓俞"),
	商曲("商曲"),
	石关("石关"),
	阴都("阴都"),
	腹通谷("腹通谷"),
	幽门("幽门"),
	步廊("步廊"),
	神封("神封"),
	灵墟("灵墟"),
	神藏("神藏"),
	彧中("彧中"),
	俞府("俞府"),
	天池("天池"),
	天泉("天泉"),
	曲泽("曲泽"),
	郄门("郄门"),
	间使("间使"),
	内关("内关"),
	大陵("大陵"),
	劳宫("劳宫"),
	中冲("中冲"),
	关冲("关冲"),
	液门("液门"),
	中渚("中渚"),
	阳池("阳池"),
	外关("外关"),
	支沟("支沟"),
	会宗("会宗"),
	三阳络("三阳络"),
	四渎("四渎"),
	天井("天井"),
	清冷渊("清冷渊"),
	消泺("消泺"),
	臑会("臑会"),
	肩髎("肩髎"),
	天髎("天髎"),
	天牖("天牖"),
	翳风("翳风"),
	瘈脉("瘈脉"),
	颅息("颅息"),
	角孙("角孙"),
	耳门("耳门"),
	耳和髎("耳和髎"),
	丝竹空("丝竹空"),
	瞳子髎("瞳子髎"),
	听会("听会"),
	上关("上关"),
	颔厌("颔厌"),
	悬颅("悬颅"),
	悬厘("悬厘"),
	曲鬓("曲鬓"),
	率谷("率谷"),
	天冲("天冲"),
	浮白("浮白"),
	头窍阴("头窍阴"),
	完骨("完骨"),
	本神("本神"),
	阳白("阳白"),
	头临泣("头临泣"),
	目窗("目窗"),
	正营("正营"),
	承灵("承灵"),
	脑空("脑空"),
	风池("风池"),
	肩井("肩井"),
	渊腋("渊腋"),
	辄筋("辄筋"),
	日月("日月"),
	京门("京门"),
	带脉("带脉"),
	五枢("五枢"),
	维道("维道"),
	居髎("居髎"),
	环跳("环跳"),
	风市("风市"),
	中渎("中渎"),
	膝阳关("膝阳关"),
	阳陵泉("阳陵泉"),
	阳交("阳交"),
	外丘("外丘"),
	光明("光明"),
	阳辅("阳辅"),
	悬钟("悬钟"),
	丘墟("丘墟"),
	足临泣("足临泣"),
	地五会("地五会"),
	侠溪("侠溪"),
	足窍阴("足窍阴"),
	大敦("大敦"),
	行间("行间"),
	太冲("太冲"),
	中封("中封"),
	蠡沟("蠡沟"),
	中都("中都"),
	膝关("膝关"),
	曲泉("曲泉"),
	阴包("阴包"),
	足五里("足五里"),
	阴廉("阴廉"),
	急脉("急脉"),
	章门("章门"),
	期门("期门"),
	长强("长强"),
	腰俞("腰俞"),
	腰阳关("腰阳关"),
	命门("命门"),
	悬枢("悬枢"),
	脊中("脊中"),
	中枢("中枢"),
	筋缩("筋缩"),
	至阳("至阳"),
	灵台("灵台"),
	神道("神道"),
	身柱("身柱"),
	陶道("陶道"),
	大椎("大椎"),
	哑门("哑门"),
	风府("风府"),
	脑户("脑户"),
	强间("强间"),
	后顶("后顶"),
	百会("百会"),
	前顶("前顶"),
	囟会("囟会"),
	上星("上星"),
	神庭("神庭"),
	素髎("素髎"),
	水沟("水沟"),
	兑端("兑端"),
	龈交("龈交"),
	会阴("会阴"),
	曲骨("曲骨"),
	中极("中极"),
	关元("关元"),
	石门("石门"),
	气海("气海"),
	阴交("阴交"),
	神阙("神阙"),
	水分("水分"),
	下脘("下脘"),
	建里("建里"),
	中脘("中脘"),
	上脘("上脘"),
	巨阙("巨阙"),
	鸠尾("鸠尾"),
	中庭("中庭"),
	膻中("膻中"),
	玉堂("玉堂"),
	紫宫("紫宫"),
	华盖("华盖"),
	璇玑("璇玑"),
	天突("天突"),
	廉泉("廉泉"),
	承浆("承浆"),
	百劳("百劳");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "acupoint_name"}
	override fun getLiteral(): String {return literal}
}
